import styled from 'styled-components'

const TrackDetail = styled.div`
    > p{
      color: #33333a;
      font-size: 14px;
    }
`;


const TrackBox = styled.div`
  > p {
    display: flex;
    justify-content: space-between;
    color: #00b3ff;
    font-size: 12px;
        font-family: "latobold";
    > span {
      cursor: pointer;
    }
    
    .timerSpan {
      width: 100%;
      > div {
        flex: 1;
        justify-content: space-evenly;
      }
    }
  }
.shipping{
  cursor:pointer;
}
.delivered{
  cursor:pointer;
}

`
const Icon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    svg {
      margin: 0 auto;
          z-index: 1;
    }
`
const TrackDescription = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .delivered {
      cursor:pointer;
    }
    .shipping {
      cursor:pointer;
    }
    .active {
      > button {
        background-color: #00b3ff;
      }
    }
    > div {
          display: grid;
          text-align: center;
          flex:1;
          padding : 0 5px;
      button {
        font-size: 12px;
        font-family: "latobold";
        margin: 0 auto;
        margin-top: 10px;
      }
       > p {
        font-size: 12px;
        margin-top: 4px;
        margin-bottom: 0; 
        :nth-child(2) {
          margin: 0;
        }
      }      
    }
`
const Panding = styled.p`
  color: #ff7d00 !important;
  text-transform: uppercase;
`

const Msg = styled.div`
  text-align: center;
  font-size: 18px;
  color: blue;
`
const DownloadBOL = styled.div`
    background: linear-gradient(to bottom,#61b01f 0%,#27911b 100%);
    padding: 4px 10px;
    color: #fff !important;
    border-radius: 5px;
    cursor: pointer;
    width: 154px;
    cursor: pointer;
    font-size: 14px;
`

export { TrackDetail, DownloadBOL, TrackBox, TrackDescription, Panding, Icon, Msg };